import { get, post } from "@/infra/rest";
import { useLoggedInMember } from "@/modules/auth/states";
import { ragCreateAPI } from "@/modules/sessions/requests";
import type {
  CustomGapAssessmentRagCreateRequest,
  DoraRagCreateRequest,
  FairRagCreateRequest,
  MultiFileVendorRagCreateRequest,
  NistAIRMFRagCreateRequest,
  NistCsf2RagCreateRequest,
  QARagCreateRequest,
  Soc2RagCreateRequest,
} from "@/modules/sessions/types";
import { getZaniaTeamMemberRoles } from "@/modules/team/states";
import { canAccessZaniaGapAssessment } from "@/modules/team/utils";
import { QueryKeys } from "@/shared/constants/QueryKeys";
import { useQuery } from "@tanstack/react-query";

export const emitRagCreate = (
  data:
    | FairRagCreateRequest
    | Soc2RagCreateRequest
    | NistCsf2RagCreateRequest
    | NistAIRMFRagCreateRequest
    | DoraRagCreateRequest
    | MultiFileVendorRagCreateRequest 
    | QARagCreateRequest
    | CustomGapAssessmentRagCreateRequest,
    

  callback?: (...args: any[]) => void,
) => {
  void ragCreateAPI(data, callback);
};

interface RAGDataRequest {
  task: string;
  output_format: string;
  response_quality: string;
  agent_session_id: string;
  use_for_ai_training?: boolean;
}

interface RAGResponse {
  success: boolean;
  message: string;
  data: {
    file_url: string;
    output_format: string;
  };
}

export const getRAGExcelFromJSON = (data: RAGDataRequest) => {
  return post<RAGDataRequest, RAGResponse>({
    url: "/v1/rag/converter",
    data,
  });
};

export const getFrameworksList = async () => {
  const response = await get<any>({
      url:  "/v0/frameworks/custom/gap_assessment",
    });
    response.mapping = response?.data.reduce((acc: any, curr: any) => {
        acc[curr.id] = curr.framework_name
        return acc
      }, {});
    return response;
};

export const useGetFrameworksListQuery= ({isEnabled}: any) => {


  const loggedInMember = useLoggedInMember();
  const memId = loggedInMember?.member_id || "";

  const {
          
          canAccessZaniaGapAssessment,
          
        } = getZaniaTeamMemberRoles(memId);
  return useQuery({
    queryKey: [QueryKeys.AllFrameworksList],
    queryFn: getFrameworksList,
    enabled: isEnabled && canAccessZaniaGapAssessment
  });
};
